import React, {ReactElement} from "react";
import './TabbedPageHeader.css';

import {LinkWithParams, useNavigateWithParams} from "../util/NavUtils";
import {ActionButton} from "../util/UI/ActionButton";
import {RpcState} from "../util/RpcState";

type Props = {

  pageTitle: string | ReactElement,

  // One of link or onClick should get set.
  buttons?: {
    text: string, 
    link?: string, 
    onClick?: () => void, 
    isSecondary?: boolean,
    rpcState?: RpcState
  }[] | undefined,

  tabs?: {
    label: string,
    link: string,
    isSelected?: boolean
  }[]
}

/**
 * For mobile or small screens (less than 800px wide) this shows a hamburger icon
 * with dropdown options for navigation in place of the left nav.
 * @param props
 * @constructor
 */

export const TabbedPageHeader = (props: Props) => {

  const navigate = useNavigateWithParams();


  return <div className={'TabbedPageHeader'}>
    <div className={'TabbedPageHeaderRow'}>

      <h1>{props.pageTitle}</h1>
      {props.buttons?.map((button, index) => <div key={'tab-' + index}>
        <ActionButton secondary={button.isSecondary} rpcState={button.rpcState} onClick={() => {
          if (button.link) {
            navigate(button.link);
          } else if (button.onClick) {
            button.onClick();
          }
        }}>
          {button.text}
        </ActionButton>
      </div>)}
    </div>
    <div className={'TabbedPageTabRow'}>
      {props.tabs?.map((tab, index) => {
        return <div key={'tab-' + index}>
          <LinkWithParams className={tab.isSelected ? 'TabbedPageButton TabbedPageButtonSelected' : 'TabbedPageButton'}
                          to={tab.link}>{tab.label}
          </LinkWithParams>
        </div>
      })}
    </div>
  </div>

}